import { defaultServiceTvanState } from './module-servicetvan-state';

export default {
	resetState(state) {
		Object.assign(state, defaultServiceTvanState);
	},
	updateData: function(state, res) {
		state.regisHistory.removeAll();
		state.regisHistory.append(res.Data.Data);
		state.Total = res.Data.Total;
	},
	updateServiceRegisTaxPay: function(state, res) {
		state.taxPayRegisInfo = res.Data;
	},
	updateServiceRegisTaxDec: function(state, res) {
		state.taxDecRegisInfo = res.Data;
	},
	bankListByTaxCode: function(state, res) {
		state.bankListByTaxCode.removeAll();
		state.bankListByTaxCode.append(res.Data);
	},
	updateDecTaxContactAdditionalList: function(state, res) {
		state.listDecTaxContactAdditional.removeAll();
		state.listDecTaxContactAdditional.append(res.Data);
	},
	updatePayTaxContactAdditionalList: function(state, res) {
		state.listPayTaxContactAdditional.removeAll();
		state.listPayTaxContactAdditional.append(res.Data);
	},
	updateWaitingProcessDec: function(state, data) {
		state.isWaitingProcessDec = data;
	},
	updateWaitingProcessPay: function(state, data) {
		state.isWaitingProcessPay = data;
	},
	updateIsRegisDeclareTax: function(state, data) {
		state.isRegisServiceDeclareTax = data;
	},
	updateIsRegisServicePayTax: function(state, data) {
		state.isRegisServicePayTax = data;
	},
	updateDecRegis: function(state, payload) {
		state.DecRegis = payload;
	},
	updatePayRegis: function(state, payload) {
		state.PayRegis = payload;
	},
	setDecTaxCheckCompleted: function(state, value) {
		state.isDecTaxCheckCompleted = value;
	},
	setPayTaxCheckCompleted: function(state, value) {
		state.isPayTaxCheckCompleted = value;
	},
	updateDecServiceRegisInfo: function(state, payload) {
		state.DecRegis = {
			...state.DecRegis,
			ServiceRegisInfo: payload.ServiceRegisInfo,
			IsServiceRegisInfo: payload.IsServiceRegisInfo
		};
	},
	updatePayServiceRegisInfo: function(state, payload) {
		state.PayRegis = {
			...state.PayRegis,
			ServiceRegisInfo: payload.ServiceRegisInfo,
			IsServiceRegisInfo: payload.IsServiceRegisInfo
		};
	}
};
